// Base styles
import * as formControlLabelStatic from "assets/components-static-styles/components/form/formControlLabel";
import colors from "assets/theme/base/colors";

// Helper functions
import { merge } from "lodash";

const { dark } = colors;

// types
type Types = any;

const themeStyles = {
  styleOverrides: {
    label: {
      color: dark.main,

      "&.Mui-disabled": {
        color: dark.main,
      },
    },
  },
};

const formControlLabel: Types = merge(themeStyles, formControlLabelStatic.default);

export default formControlLabel;
